import Vue from 'vue'
import Router from 'vue-router'
import login from '../Login/login.vue'
import Home from '../views/home.vue'
import order from '../views/order.vue'
import CommodityOrder from '../views/CommodityOrder/CommodityOrder.vue'
import shoppingCart from '../views/shoppingCart/shoppingCart.vue'
import posLogin from '../poslogin/posLogin.vue'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: login
    },
    // 登录页
    {
      path: '/login',
      name: 'login',
      redirect: '/',
      component: login
    },
    {   //商品列表
      path: '/home',
      name: 'home',
      component: Home,
      meta:{
        keepAlive:true,
        flag:true
      }
    },
    {
      // 商品详情
      path: '/order',
      name: "order",
      component: order,
    },
    {
      // 我的订单
      path: '/CommodityOrder',
      name: 'CommodityOrder',
      component: CommodityOrder,
    },
    {
      // 我的订单
      path: '/shoppingCart',
      name: 'shoppingCart',
      component: shoppingCart,
    },
    {
      // pos登录页
      path: '/poslogin',
      name: 'poslogin',
      component: posLogin,
    }
  ]
})
export default router
